const inputFieldsMaps = {
  pl: {
    A: [
      {
        label: "Ilość kontrolerów na zmianę:",
        id: "A1",
        value: 0,
        unit: "",
        tip: "Wpisz, ilu kontrolerów jakości pracuje na pojedynczej zmianie.",
      },
      {
        label: "Ilość zmian na dzień produkcyjny:",
        id: "A2",
        value: 0,
        unit: "",
        tip: "Ile zmian pracuje podczas jednego dnia produkcyjnego (1/2/3)?",
      },
      {
        label: "Ilość dni produkcyjnych w miesiącu:",
        id: "A3",
        value: 0,
        unit: "",
        tip: "Przez ile dni w miesiącu odbywa się produkcja?",
      },
      {
        label: "Stawka godzinowa (brutto) Kontrolera Jakości:",
        id: "A4",
        value: 0,
        unit: "PLN",
        tip: "Wg. danych z rynku w 2023 roku koszt pojedynczego operatora w Automotive wraz z kosztami pośrednimi to ok to 55 PLN/h . W przypadku zlecenia kontroli firmie zewnętrznej było to około 40 PLN/h.",
      },
    ],
    B: [
      {
        label: "Wolumen produkcyjny miesięczny:",
        id: "B1",
        value: 0,
        unit: "szt",
        tip: "Ile sztuk produktu jest produkowane w ciągu miesiąca na linii produkcyjnej?",
      },
      {
        label: "Procent brakowości przed wdrożeniem Systemu Wizyjnego:",
        id: "B2",
        value: 0,
        unit: "%",
        tip: "Jak dużo produktów NOK powstaje miesięcznie z uwagi na brak ciągłej kontroli procesu?",
      },
      {
        label: "Koszt brakowania pojedynczego produktu:",
        id: "B3",
        value: 0,
        unit: "PLN",
        tip: "Jakie są szacunkowe koszty związane z utylizacją 1 szt. produktu NOK (koszty odpadu, koszty pracy, koszt zużytych półproduktów itp.)?",
      },
    ],
    C: [
      {
        label: "Ilość reklamacji przed Wdrożeniem Systemu Wizyjnego (rocznie):",
        id: "C1",
        value: 0,
        unit: "",
        tip: "Ile średnio rocznie jest otrzymywanych reklamacji na linii, dla której wyliczasz ROI?",
      },
      {
        label: "Średni koszt bezpośredni reklamacji:",
        id: "C2",
        value: 0,
        unit: "PLN",
        tip: "Jakie są średnio koszty bezpośrednie pojedynczej reklamacji, takie jak kara umowna, konieczność ponownej wysyłki, koszty sortowania produktów? W branży Automotive średni bezpośredni koszt pojedynczej reklamacji to najczęściej kwota w przedziale 85 000 - 220 000 PLN.",
      },
      {
        label: "Koszty obsługi pojedynczej reklamacji:",
        id: "C3",
        value: 0,
        unit: "PLN",
        tip: "Jakie są szacunkowo średnie łączne koszty pośrednie związane z obsługą pojedynczej reklamacji tj. zaangażowanie osób w wyjaśnianie sytuacji, spotkania, wizyty u Klienta, koszty audytów, przygotowywanie i wdrażanie planu naprawczego etc. Średnia stawka Inżyniera Jakości w 2023 wraz z narzutami to 60 PLN/h, natomiast Managera Jakości - ok. 80 PLN/h.",
      },
    ],
    D: [
      {
        label: "Wolumen produkcyjny miesięczny:",
        id: "D1",
        value: 0,
        unit: "szt",
        tip: "Ile sztuk produktu jest produkowane w ciągu miesiąca na linii produkcyjnej?",
      },
      {
        label:
          "Procent braków, które niepotrzebnie trafiają do dalszego procesu:",
        id: "D2",
        value: 0,
        unit: "%",
        tip: "Ile szacunkowo % produkcji jest odrzucane dopiero po lakierowaniu, wypalaniu, etykietowaniu czy też np. uzbrojeniu w komponenty (wkładki gwintowe, nity , etc.)",
      },
      {
        label:
          "Koszt przetwarzania (lakierowanie, wypalanie, drukowanie, transport etc) pojedynczego produktu:",
        id: "D3",
        value: 0,
        unit: "PLN",
        tip: "Ile kosztuje średnio lakierowanie/wypalanie/etykietowanie/uzbrajanie pojedynczego produktu?",
      },
    ],
    E: [
      {
        label:
          "Koszt pojedynczej awarii (wymiana formy/narzędzia w\u00A0uszkodzonej maszynie, inne naprawy):",
        id: "E1",
        value: 0,
        unit: "PLN",
        tip: "Ile szacunkowo kosztuje nowa forma/narzędzie oraz naprawy elementów, które ulegają zniszczeniu podczas awarii?",
      },
      {
        label: "Koszt postoju linii wywołanego błędem obsługi:",
        id: "E2",
        value: 0,
        unit: "PLN",
        tip: "Jak długo produkcja jest zatrzymana w przypadku takiej awarii i jaki jest koszt związany z brakiem możliwości produkcji (straty produkcyjne)? Jakie grożą konsekwencje z tytułu braku produkcji (reklamacja Klienta, kary umowne itp.)? Jakie dodatkowe działania (naprawa, wymiana, serwis) są wykonywane i ile szacunkowo kosztują?",
      },

      {
        label: "Ilość zdarzeń w roku:",
        id: "E3",
        value: 0,
        unit: "",
        tip: "Do ilu awarii dochodzi średnio w roku?",
      },
    ],
  },
  en: {
    A: [
      {
        label: "Number of controllers per shift:",
        id: "A1",
        value: 0,
        unit: "",
        tip: "Enter how many quality controllers work on a single shift.",
      },
      {
        label: "Number of shifts per production day:",
        id: "A2",
        value: 0,
        unit: "",
        tip: "How many shifts work during one production day (1/2/3)?",
      },
      {
        label: "Number of production days per month:",
        id: "A3",
        value: 0,
        unit: "",
        tip: "How many days a month does production take place?",
      },
      {
        label: "Hourly rate of a Quality Controller:",
        id: "A4",
        value: 0,
        unit: "EUR",
        tip: "According to data from the market in 2023, the cost of a single operator in Automotive including indirect costs is approximately EUR 12,8/h . In the case of outsourcing the inspection to an external company, it was approximately EUR 9,3/h.",
      },
    ],
    B: [
      {
        label: "Monthly production volume:",
        id: "B1",
        value: 0,
        unit: "pcs",
        tip: "How many pieces of the product are produced per month on the production line?",
      },
      {
        label:
          "Percentage of defects before the implementation of the Vision System:",
        id: "B2",
        value: 0,
        unit: "%",
        tip: "How many NOK products are produced per month due to the lack of continuous process control?",
      },
      {
        label: "Cost of scrapping a single product:",
        id: "B3",
        value: 0,
        unit: "EUR",
        tip: "What are the estimated costs associated with the disposal of 1 pcs. NOK product (waste costs, labor costs, cost of used semi-finished products, etc.)",
      },
    ],
    C: [
      {
        label:
          "Number of complaints before the Implementation of the Vision System (annually):",
        id: "C1",
        value: 0,
        unit: "",
        tip: "On average, how many complaints are received annually on the line for which you calculate ROI?",
      },
      {
        label: "Average direct cost of a complaint:",
        id: "C2",
        value: 0,
        unit: "EUR",
        tip: "What are, on average, the direct costs of a single complaint, such as contractual penalties, the need for re-dispatch, product sorting costs? In the automotive industry, the average direct cost of a single complaint is usually in the range of EUR 19,770 - 51,790.",
      },
      {
        label: "Costs of handling a single complaint:",
        id: "C3",
        value: 0,
        unit: "EUR",
        tip: "What are the estimated average total indirect costs associated with handling a single complaint, i.e. the involvement of people in explaining the situation, meetings, visits to the client, costs of audits, preparation and implementation of the remediation plan, etc.? The average rate for a Quality Engineer in 2023, including surcharges, is 14 EUR/h, while for a Quality Manager it is approximately 19 EUR/h.",
      },
    ],
    D: [
      {
        label: "Monthly production volume:",
        id: "D1",
        value: 0,
        unit: "pcs",
        tip: "How many pieces of the product are produced per month on the production line?",
      },
      {
        label:
          "Percentage of defects that are unnecessarily transferred to the next process:",
        id: "D2",
        value: 0,
        unit: "%",
        tip: "How many estimated % of production is rejected only after painting, burning, labelling or e.g. equipping with components (thread inserts, rivets, etc.)",
      },
      {
        label:
          "Cost of processing (varnishing, firing, printing, transport, etc.) of a single product:",
        id: "D3",
        value: 0,
        unit: "EUR",
        tip: "How much does it cost on average to varnish/burn/label/set up a single product?",
      },
    ],
    E: [
      {
        label:
          "Cost of a single malfunction (replacement of a mold/tool in a damaged machine, other repairs):",
        id: "E1",
        value: 0,
        unit: "EUR",
        tip: "How much does it cost to have a new mold/tool and repairs to components that are destroyed during malfunction?",
      },
      {
        label: "Cost of line downtime caused by staff error:",
        id: "E2",
        value: 0,
        unit: "EUR",
        tip: "How long is production halted in the event of such a failure and what is the cost associated with not being able to produce (production losses)? What are the consequences of not being able to produce (customer complaint, contractual penalties, etc.)? What additional activities (repair, replacement, service) are carried out and how much do they estimate they cost?",
      },

      {
        label: "Number of events per year:",
        id: "E3",
        value: 0,
        unit: "",
        tip: "How many breakdowns occur on average per year?",
      },
    ],
  },
};

export default inputFieldsMaps;
